import calculateTimeDifference from "./calculateTimeDifference";
import { humanized } from "./locales";
var humanize = function humanize(date) {
  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'es';
  var langKey = lang;
  return calculateTimeDifference(date, humanized[langKey]);
};
export default humanize;